import { RoadStretch } from "../../../constants/action-constants/RoadStretchActionConstants";

export const selectRoadStretch = (roadStretch) => ({
  type: RoadStretch.SELECT_ROAD_STRETCH,
  payload: { roadStretch },
});

export const selectRoadStretches = (roadStretchesMap) => ({
  type: RoadStretch.SELECT_ROAD_STRETCHES,
  payload: { roadStretchesMap },
});

export const unselectRoadStretch = (roadStretch) => ({
  type: RoadStretch.UN_SELECT_ROAD_STRETCH,
  payload: { roadStretch },
});

export const selectMultiRoadStretches = (roadStretchesMap) => ({
  type: RoadStretch.SELECT_MULTI_ROAD_STRETCHES,
  payload: { roadStretchesMap },
});

export const unSelectMultiRoadStretches = (roadStretchesMap) => ({
  type: RoadStretch.UN_SELECT_MULTI_ROAD_STRETCHES,
  payload: { roadStretchesMap },
});

export const resetCityRoadStretches = () => ({
  type: RoadStretch.RESET_ROAD_STRETCHES,
});

export const getRoadStretchesByCityId = (
  cityId,
  isArchived,
  isDigitalMedias,
  arterialRoutes,
  mediaTypes,
  zones,
  freqOptLocations,
  setSelectedTab // key to close Tab
) => ({
  type: RoadStretch.GET_CITY_ROAD_STRETCHES,
  payload: {
    cityId,
    isArchived,
    isDigitalMedias,
    arterialRoutes,
    mediaTypes,
    zones,
    freqOptLocations,
    setSelectedTab,
  },
});

export const getTouchPointsFilteredStretches = (
  touchPoints,
  setSelectedTab // optional
) => ({
  type: RoadStretch.GET_TOUCH_POINTS_FILTERED_STRETCHES,
  payload: { touchPoints, setSelectedTab },
});

export const filterCityRoadStretches = (
  zones,
  freqOptLocations,
  arterialRoutes,
  mediaTypes,
  appliedFrom,
  setSelectedTab // key to close Tab
) => ({
  type: RoadStretch.FILTER_CITY_ROAD_STRETCHES,
  payload: {
    zones,
    freqOptLocations,
    arterialRoutes,
    mediaTypes,
    appliedFrom,
    setSelectedTab,
  },
});

export const getFreqOptLocFilteredStretches = (freqOptLocations) => ({
  type: RoadStretch.GET_FOL_FILTERED_STRETCHES,
  payload: { freqOptLocations },
});
